import { useTranslation } from "react-i18next";
import { Therapist } from "../../../therapist";

interface UserMetaCardProps {
  therapist: Therapist | null;
}

export default function UserMetaCard({ therapist }: UserMetaCardProps) {
  const { t } = useTranslation();
  return (
    <div className="glass-effect glass-border border rounded-3xl p-8 shadow-theme-sm overflow-hidden relative">
      <div className="flex flex-col md:flex-row items-center gap-8">
        {/* The same picture the header avatar uses. Having one is separate
            from publishing it — that is the public profile's own switch. */}
        {therapist?.photo_url ? (
          <img
            src={therapist.photo_url}
            alt={[therapist.first_name, therapist.last_name].filter(Boolean).join(" ")}
            className="h-24 w-24 shrink-0 rounded-full object-cover"
          />
        ) : (
          <span
            aria-hidden="true"
            className="grid h-24 w-24 shrink-0 place-items-center rounded-full bg-brand-100 text-brand-700 dark:bg-brand-900 dark:text-brand-200 text-title-sm font-semibold"
          >
            {[therapist?.first_name, therapist?.last_name]
              .filter(Boolean)
              .map((part) => part?.[0]?.toUpperCase())
              .join("")}
          </span>
        )}
        <div className="flex-1 text-center md:text-left">
          <h4 className="text-2xl font-extrabold text-content-primary">
            {therapist
              ? [therapist.first_name, therapist.last_name].filter(Boolean).join(" ")
              : t("common.loading")}
          </h4>
          <p className="text-brand-600 dark:text-brand-400 font-medium mt-1">
            {therapist?.email ?? ""}
          </p>
        </div>
      </div>

      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -tr-x-1/4 -tr-y-1/4 w-32 h-32 bg-brand-500/5 rounded-full blur-3xl pointer-events-none" />
    </div>
  );
}
